import { Icon } from '@iconify/react';

function App(props) {

  var tabitems = props.tabitems;
  return tabitems.map((anItem, index)=>{
    var imgOrIcon;
    if (anItem.a){
      imgOrIcon = <Icon width='80' icon={anItem.a} /> 
  //
    }else if (anItem.i){
      imgOrIcon = <img src={anItem.i} alt={anItem.t}/>
    }
    var className = 'col-md-5 cardBlockchain col-11';
    if (anItem.s){
      className += ' cardBlockchainSelected';
    }
    return <div key={index} className={className} onClick={anItem.f}> <div> <div className="thumbnailbc">{imgOrIcon}</div> <p className="description2">{anItem.t}</p>{anItem.elab}</div> </div>
  })


//
}

export default App;
